<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.3335 13.3333V6.66666M5.3335 13.3333L3.3335 11.3333M5.3335 13.3333L7.3335 11.3333M10.6668 2.66666V9.33332M10.6668 2.66666L12.6668 4.66666M10.6668 2.66666L8.66683 4.66666" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
